export enum PaywallABTestVariant {
  ELEVENLABS = "elevenlabs",
}
